// extracted by mini-css-extract-plugin
module.exports = {"main":"FileDownloader_main__1zy9P","btnArea":"FileDownloader_btnArea__26Ch3","header":"FileDownloader_header__1HM3S","title":"FileDownloader_title__2V1TN"};